export function useGetSomeChartData(data) {

    const config = {

        type: 'bar',
        data: {
            labels: data.map(each => each.label),
            datasets: [{
                label: 'Other Data',
                data: data.map(each => each.value),
                borderWidth: 1,
                backgroundColor: [
                    'rgba(95,95,95,0.5)',
                    'rgba(95,95,95,0.5)',
                    'rgba(95,95,95,0.5)',
                    'rgba(95,95,95,0.5)',
                    'rgba(95,95,95,0.5)',
                    'rgba(95,95,95,0.5)',
                ],
            }],

        },
        options: {
            indexAxis: 'y',
            plugins: {
                legend: {
                    display: true,
                    position: 'top',
                    labels: {
                        boxWidth: 13,
                    }
                },

            },
            responsive: true,
            hoverOffset: 15,
            scales: {},
            layout: {
                padding: 20,
                font: {
                    family: 'roboto'
                }
            }
        }

    }

    return config;

}
